const inMiniProgramWebview = () => {
  const ua = navigator.userAgent.toLowerCase();

  if (ua.includes('micromessenger') && ua.includes('miniprogram')) {
    console.log('当前环境是微信小程序 WebView');
    return true;
  } else if (ua.includes('alipayclient') && ua.includes('apdwebview')) {
    console.log('当前环境是支付宝小程序 WebView');
    return true;
  } else if (ua.includes('toutiaomicroapp')) {
    console.log('当前环境是抖音/头条小程序 WebView');
    return true;
  } else {
    console.log('当前环境不是小程序 WebView');
    return false;
  }
};

/**
 * 判断页面是否运行在微信小程序webview
 */
export const isMiniProgram = function () {
  const isMP = inMiniProgramWebview();
  return isMP;
};
